import axios from 'axios';
import config from '../config';

const API = axios.create({
  baseURL: config.API_BASE_URL,
});

// Ajouter le token automatiquement à chaque requête
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const inscription = (data) => API.post('/auth/inscription', data);
export const connexion = (data) => API.post('/auth/connexion', data);
export const motDePasseOublie = (email) => API.post('/auth/mot-de-passe-oublie', { email });
export const reinitialiserMotDePasse = (token, mot_de_passe) => API.post('/auth/reinitialiser-mot-de-passe', { token, mot_de_passe });
export const monProfil = () => API.get('/auth/profil');
export const mettreAjourInfosProfil = (data) => API.put('/auth/profil-infos', data);

// Annonces
export const listerAnnonces = (params) => API.get('/annonces', { params });
export const detailAnnonce = (id) => API.get(`/annonces/${id}`);
export const creerAnnonce = (data) => API.post('/annonces', data);
export const modifierAnnonce = (id, data) => API.put(`/annonces/${id}`, data);
export const supprimerAnnonce = (id) => API.delete(`/annonces/${id}`);
export const mesAnnonces = () => API.get('/annonces/user/mes-annonces');
export const mettreEnAvant = (id) => API.put(`/annonces/${id}/mise-en-avant`);
export const changerStatut = (id, statut) => API.put(`/annonces/${id}/statut`, { statut });
export const renouvelerAnnonce = (id) => API.put(`/annonces/${id}/renouveler`);
export const contactWhatsapp = (id) => API.post(`/annonces/${id}/contact`);
export const contactWhatsappLocation = (id) => API.post(`/locations/${id}/contact`);

// Messages
export const envoyerMessage = (data) => API.post('/messages', data);
export const mesConversations = () => API.get('/messages/conversations');
export const conversation = (userId) => API.get(`/messages/conversation/${userId}`);
export const messagesNonLus = () => API.get('/messages/non-lus');

// Favoris
export const ajouterFavori = (annonce_id) => API.post('/favoris', { annonce_id });
export const supprimerFavori = (annonce_id) => API.delete(`/favoris/${annonce_id}`);
export const mesFavoris = () => API.get('/favoris');

export default API;
